import React from 'react';
import CoverageEditor from '../components/CoverageEditor';

const CoveragePage = () => (
  <div className="max-w-5xl mx-auto px-4 py-10" data-testid="coverage-page">
    <div className="mb-8">
      <h1 className="font-heading font-semibold text-4xl mb-2">Zona di copertura</h1>
      <p className="text-foreground/70 text-sm max-w-2xl">
        Seleziona sulla mappa i CAP in cui operi. Le richieste dei clienti vengono smistate in base al
        CAP dell&apos;indirizzo della prestazione. Se nella tua città operano dei Centri di Assistenza,
        verrai assegnato automaticamente al Centro che gestirà le richieste.
      </p>
    </div>
    <CoverageEditor />
  </div>
);

export default CoveragePage;
